import { Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface BackgroundCheckInfoSectionProps {
  title: string;
  children: React.ReactNode;
}

export function BackgroundCheckInfoSection({ title, children }: BackgroundCheckInfoSectionProps) {
  return (
    <Stack spacing={2}>
      <Title semibold variant="h5" component="h2">
        {title}
      </Title>
      {children}
    </Stack>
  );
}
